@if (isMiddleOffice()) {
  <app-middle-office-button [type]="'EDIT_STORE_SCHEDULES'" class="middle-office" />
}

<ul class="list">
  @for (schedule of schedules(); track schedule; let index = $index) {
    <li class="list-item">
      <div class="day">{{ index | getDay }}</div>
      <div class="day-schedules">
        {{ schedule.slots }}
      </div>
    </li>
  }
</ul>

@if (specialOpening() && specialOpening()!.length > 0) {
  <ul class="special-opening">
    @for (date of specialOpening(); track date) {
      <li>{{ date }}</li>
    }
  </ul>
}

@if (isMiddleOffice()) {
  <app-middle-office-button [type]="'EDIT_EXCEPTIONAL_STORE_SCHEDULES'" class="middle-office" />
}
